export default __webpack_public_path__ + "static/media/olusola.bd8c53c1.jpg";